import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@mui/material';
import Stack from '@mui/material/Stack';
import { forwardRef } from 'react';
import { DataSet } from '../../atoms/DataSet/DataSet';
import { useTheme } from '../../theme';
const paddingTypes = ['none', 'default'];
const paddingTypeToNumberMap = {
    none: 0,
    default: 104,
    // add more options here if needed
};
export const SummaryTable = forwardRef(function SummaryTable({ data, stripes, direction = 'column', padding = 'default', }, ref) {
    const theme = useTheme();
    return (_jsx(Stack, { spacing: stripes ? 0 : paddingTypeToNumberMap[padding], ref: ref, direction: direction, justifyContent: direction === 'row' ? 'space-between' : 'flex-start', children: data.map((element, index) => (_jsx(Box, { padding: stripes ? paddingTypeToNumberMap[padding] : 0, bgcolor: stripes && index % 2 ? `${theme.palette.primary.main}1A` : 'none', children: typeof element.value === 'string' && direction === 'column' ? (_jsx(DataSet, { label: element.label, value: element.value, direction: "row" })) : (_jsx(DataSet, { label: element.label, value: element.value, direction: "column" })) }, index))) }));
});
